module.exports = __webpack_public_path__ + "static/media/admission form.15ef4efe.svg";